import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import { StatusBadge } from "@/components/StatusBadge";
import type { LineSummary } from "@/types/lines.types";

interface ProductOption {
  id: string;
  name: string;
}

interface Props {
  lines: LineSummary[];
  products: ProductOption[];
  lineId: string | null;
  productId: string | null;
  onLine: (id: string) => void;
  onProduct: (id: string) => void;
}

// "onde simular". O produto entra aqui, e não no passo do objetivo, porque é
// característica da linha a avaliar, não da pergunta: a mesma linha responde as três perguntas
// sobre o mesmo produto. Com um produto só cadastrado, some da frente (preseleção no orquestrador).
export function LinePicker({ lines, products, lineId, productId, onLine, onProduct }: Props) {
  return (
    <div className="space-y-3">
      <div>
        <p className="mb-2 text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
          Onde?
        </p>
        {lines.length === 0 ? (
          <p className="rounded-md border border-dashed p-3 text-[13px] text-muted-foreground">
            Nenhuma linha cadastrada para simular. Monte uma linha nova a partir do acervo.
          </p>
        ) : (
          <div className="flex max-h-52 flex-col gap-1.5 overflow-y-auto">
            {lines.map((l) => (
              <button
                key={l.id}
                type="button"
                onClick={() => onLine(l.id)}
                className={
                  l.id === lineId
                    ? "flex items-center gap-2.5 rounded-md border border-primary/60 bg-muted/30 px-3 py-2 text-left"
                    : "flex items-center gap-2.5 rounded-md border px-3 py-2 text-left transition-colors hover:border-primary/40 hover:bg-muted/30"
                }
              >
                <span className="flex-1">
                  {/* Status SEMPRE com rótulo, nunca só cor: um ponto colorido deixava "parada" e
                      "ociosa" indistinguíveis. `StatusBadge` é o componente canônico do sistema. */}
                  <span className="flex items-center gap-2 text-sm font-semibold">
                    {l.name}
                    <StatusBadge status={l.status} kind="line" size="sm" pulse={false} />
                  </span>
                  <span className="block font-mono text-[11px] text-muted-foreground">
                    {l.machineCount} máquina{l.machineCount === 1 ? "" : "s"}
                  </span>
                </span>
              </button>
            ))}
          </div>
        )}
      </div>

      {products.length > 1 ? (
        <div className="space-y-1">
          <Label htmlFor="start-product">Produto</Label>
          <Select
            id="start-product"
            value={productId ?? ""}
            onChange={(e) => onProduct(e.target.value)}
          >
            <option value="">Selecione…</option>
            {products.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </Select>
        </div>
      ) : null}
    </div>
  );
}
